export const TOGGLE_FETCHING_ANALYSIS = "TOGGLE_FETCHING_ANALYSIS";
export const SET_ANALYSIS = "SET_ANALYSIS";

export const TOGGLE_FETCHING_MONTHLY_REVENUE =
  "TOGGLE_FETCHING_MONTHLY_REVENUE";
export const SET_MONTHLY_REVENUE = "SET_MONTHLY_REVENUE";

export const TOGGLE_FETCHING_TRANSACTIONS = "TOGGLE_FETCHING_TRANSACTIONS";
export const SET_TRANSACTIONS = "SET_TRANSACTIONS";
